import React from 'react';
import PropTypes from 'prop-types';

const TrackingPixels = ({
  timestamp,
  pixels,
}) => {
	if (typeof(pixels) === 'undefined' || pixels === null || pixels.length <= 0) {
		return null;
	}
	const renderedPixels = pixels.map(pixel => {
		const url = pixel.replace('[timestamp]', timestamp);
			return (<img src={url} width="1" height="1" alt="Advertisement" />);
		});
		return renderedPixels;
	};

TrackingPixels.propTypes = {
  timestamp: PropTypes.string,
  pixels: PropTypes.array,
};

export default TrackingPixels;
